import sorryKidPath from 'assets/photo/letter-number-formations/sorry-kid.png';
import { translate } from '../translations/translator';
const t = (key: string) => translate('lnf', key);

function MissingLicense() {
  function handleClose() {
    window.close();
  }

  return (
    <section className="missing-license-page">
      <img src={sorryKidPath} alt="Oops! Kid holding sorry sign" />
      <div>
        <span>{t('403error')}</span>
        <h1>{t('accessForbidden')}</h1>
        <h2>{t('doNotHaveAccess')}</h2>
        <button onClick={handleClose}>{t('close')}</button>
      </div>
    </section>
  );
}

export default MissingLicense;
